import AppDataService from './AppDataService'

const COMMON_BASE = 'master'

export default class MasterService {

    static async getMasterAllergyList(payload) {        
        return await AppDataService.get(`${COMMON_BASE}/allergy?page=${payload?.page || 1}`)
    }
    static async createMasterAllergy(data) {
        return await AppDataService.post(`${COMMON_BASE}/allergy`, data)
    }
    static async updateMasterAllergy(id,data) {
        return await AppDataService.patch(`${COMMON_BASE}/allergy/${id}`, data)
    }
    static async deleteMasterAllergy(id) {
        return await AppDataService.delete(`${COMMON_BASE}/allergy/${id}`)
    }
    static async bulkUploadMasterAllergy(fileData) {
        return await AppDataService.post(`${COMMON_BASE}/allergy/upload`, fileData)
    }

    static async getMasterMedicationList(payload) {        
        return await AppDataService.get(`${COMMON_BASE}/medication?page=${payload?.page || 1}`)
    }
    static async createMasterMedication(data) {
        return await AppDataService.post(`${COMMON_BASE}/medication`, data)
    }
    static async updateMasterMedication(id,data) {
        return await AppDataService.patch(`${COMMON_BASE}/medication/${id}`, data)
    }
    static async deleteMasterMedication(id) {
        return await AppDataService.delete(`${COMMON_BASE}/medication/${id}`)
    }
    static async bulkUploadMasterMedication(fileData) {
        return await AppDataService.post(`${COMMON_BASE}/medication/upload`, fileData)
    }
    static async getMasterTestUnitList(payload) {        
        return await AppDataService.get(`${COMMON_BASE}/test-unit?page=${payload?.page || 1}`)
    }
    static async createMasterTestUnit(data) {
        return await AppDataService.post(`${COMMON_BASE}/test-unit`, data)
    }
    static async updateMasterTestUnit(id,data) {
        return await AppDataService.patch(`${COMMON_BASE}/test-unit/${id}`, data)
    }
    static async deleteMasterTestUnit(id) {
        return await AppDataService.delete(`${COMMON_BASE}/test-unit/${id}`)
    }
    static async bulkUploadMasterTestUnit(fileData) {
        return await AppDataService.post(`${COMMON_BASE}/test-unit/upload`, fileData)
    }
}